import { render, staticRenderFns } from "./ButtonGoogle.vue?vue&type=template&id=54b2dd50"
import script from "./ButtonGoogle.vue?vue&type=script&lang=js"
export * from "./ButtonGoogle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports